import * as z from 'zod/mini'
import { userFields } from '../../schemas/user'

export const setWalkMeBody = z.object({ walkMeDisabled: z.boolean() })
export type SetWalkMeBody = z.infer<typeof setWalkMeBody>

/**
 * A user editing their own profile (docs/account.md). Only what is sent changes; `null` clears the birth date or
 * the gender, an empty string clears a text. The service turns `birthDate` into a `Date` and refuses to clear what
 * `requiredProfileFields` keeps.
 */
export const editUserBody = z.partial(
  z.object({
    firstName: userFields.firstName,
    lastName: userFields.lastName,
    phone: userFields.phone,
    birthDate: z.nullable(userFields.birthDate),
    gender: z.nullable(userFields.gender),
    description: userFields.description,
  }),
)
export type EditUserBody = z.infer<typeof editUserBody>
